/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Link_Other_DeviceInputs */



/**
* | output |
* | --- |
* | "This link only works in the browser where you requested it. Enter the code from the email there instead." |
*
* @param {Login_Link_Other_DeviceInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_link_other_device = /** @type {((inputs?: Login_Link_Other_DeviceInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Link_Other_DeviceInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze link werkt alleen in de browser waar je hem aanvroeg. Typ daar de code uit de e-mail in.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce lien ne fonctionne que dans le navigateur où vous l'avez demandé. Saisissez-y le code de l'e-mail.")
	return /** @type {LocalizedString} */ ("This link only works in the browser where you requested it. Enter the code from the email there instead.")
});